import React, { useState, useEffect } from 'react';

function LocationDisplay() {
    const [location, setLocation] = useState('Zisťujem polohu');

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const { latitude, longitude } = position.coords;

                    try {
                        // OpenCage reverse geocoding
                        const response = await fetch(
                            `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=7f7efcd9db4f41d9a5cd438f994a6ba0`
                        );
                        const data = await response.json();
                        const result = data.results[0].components;

                        const suburb = result.suburb || result.neighbourhood || result.city_district;
                        const city = result.city || result.town || result.village || 'Unknown location';
                        setLocation(suburb ? `${suburb}, ${city}` : city);
                    } catch (error) {
                        console.error('Error fetching city name:', error);
                        setLocation('Bratislava, Slovakia'); // fallback if API fails
                    }
                },
                (error) => {
                    console.warn('Geolocation failed, using default fallback:', error);
                    setLocation('Bratislava, Slovakia');
                }
            );
        } else {
            console.warn('Geolocation not supported, using default fallback');
            setLocation('Bratislava, Slovakia');
        }
    }, []);

    return (
        <div className="location-display">
            <i className="fas fa-map-marker-alt" aria-hidden="true"></i>
            <p>{location}</p>
        </div>
    );
}

export default LocationDisplay;
